//==============================================================================
/**
 * Available states for the child and parent components
 * @type {object} pseudo-constant
 */
const States =
  {
    READY      : "ready",
    IDLE       : "idle",
    INACTIVE   : "inactive",
    FAILED     : "failed",
    ERRORED    :  "errored",
    INITING    : "initing",
    REQUESTING : "requesting",
    ENABLING   : "enabling",
    ENABLED    : "enabled",
    DISABLING  : "disabling",
    DISABLED   : "disabled"
  };

export { States };